// extracted by mini-css-extract-plugin
module.exports = {"list":"tags_list__2PQiX","item":"tags_item__wF4ej","upperCase":"tags_upperCase__iSZUb"};